import React, { ReactNode } from "react"
import { Drawer, Stack, useTheme } from "@mui/material"
import { CardColor } from "./browser/card/BrowserCard"
import { scrollbarMixin } from "src/providers/AppProviders"

type CustomDrawerProps = {
  topBar: ReactNode
  topSection: ReactNode
  bottomSection: ReactNode
  open: boolean
  onClose: () => void
  topSectionColor: CardColor
}

const CustomDrawer: React.FC<CustomDrawerProps> = ({
  topBar,
  topSection,
  bottomSection,
  open,
  onClose,
  topSectionColor
}) => {
  const { palette } = useTheme()

  return (
    <>
      <Drawer
        anchor="right"
        open={open}
        onClose={onClose}
        PaperProps={{
          sx: {
            borderTopLeftRadius: { xs: 0, md: 20 },
            borderBottomLeftRadius: { xs: 0, md: 20 },
            overflow: "hidden"
          }
        }}
      >
        <Stack
          sx={{
            width: { xs: "100vw", md: "700px", lg: "1000px" },
            overflow: "auto",
            scrollbarGutter: { xs: "auto", md: "stable" },
            ...scrollbarMixin()
          }}
        >
          <Stack
            spacing={1}
            sx={{
              px: { xs: 3, md: 4, lg: 8 },
              py: { xs: 2.5, md: 4 },
              backgroundColor: palette[topSectionColor].light
            }}
          >
            {topBar}
            {topSection}
          </Stack>
          {bottomSection}
        </Stack>
      </Drawer>
    </>
  )
}

export default CustomDrawer
